<template>
  <multiselect
    :options="optionsList"
    :placeholder="placeholder"
    :multiple="multiple"
    :limit="1"
    selectLabel
    selectedLabel
    deselectLabel
    :close-on-select="!multiple"
    :track-by="trackBy"
    class="dark filter-multiselect"
    :class="[required ? 'required' : '']"
    :label="fieldName"
    :value="value"
    @input="$emit('input', $event)"
    :internal-search="false"
    @search-change="searchLang = $event"
    ref="select"
    @open="openHandler"
    :disabled="disabled"
  >
    <template v-slot:option="{option}">
      <span v-html="option[fieldName]"></span>
    </template>
    <template v-slot:tag="{option, remove}">
      <span class="option__tag">
        {{ option[fieldName] }}
        <i
          @click="remove(option)"
          aria-hidden="true"
          tabindex="1"
          class="multiselect__tag-icon"
        ></i>
      </span>
    </template>
    <template v-if="showAllcomp && multiple" v-slot:beforeList>
      <li class="multiselect__element" @click="selectorHandler">
        <span class="multiselect__option">
          <span v-if="value.length != options.length">
            Select all
          </span>
          <span v-else>
            Unselect all
          </span>
        </span>
      </li>
    </template>
    <template v-slot:noResult>
      <div>No results</div>
    </template>
    <template v-slot:noOptions>
      <div>No results</div>
    </template>
  </multiselect>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  name: 'FilterMultiselect',
  components: {
    multiselect: () => import('vue-multiselect'),
  },
  props: {
    value: {
      type: [Array, Object],
      default: () => Array(),
    },
    options: {
      type: Array,
      default: () => Array(),
    },
    placeholder: {
      type: String,
    },
    fieldName: {
      type: String,
      default: () => 'Name',
    },
    showAll: {
      type: Boolean,
      default: () => true,
    },
    multiple: {
      type: Boolean,
      default: () => true,
    },
    required: {
      type: Boolean,
      default: () => false,
    },
    trackBy: {
      type: String,
      default: () => 'ID',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    searchLang: '',
  }),
  methods: {
    openHandler () {
      this.$nextTick(() => {
        this.$refs.select.$el.querySelector('.multiselect__content-wrapper').scrollTop = 0;
      });
    },
    selectorHandler () {
      this.$emit('input', this.value.length !== this.options.length ? this.options : Array());
    },
  },
  computed: {
    activeOptions () {
      return Array.isArray(this.value) ? this.value.map((i) => i.ID) : Array();
    },
    showAllcomp () {
      return this.showAll && !this.searchLang && this.optionsList.length > 0;
    },
    optionsList () {
      return this.options.filter(
        (i) => !this.searchLang || i[this.fieldName].toLowerCase().includes(this.searchLang.toLowerCase())
      ).sort((a, b) => {
        if (this.activeOptions.includes(a.ID) === this.activeOptions.includes(b.ID)) {
          return a[this.fieldName] < b[this.fieldName] ? -1 : 1;
        } else {
          return this.activeOptions.includes(b.ID) - this.activeOptions.includes(a.ID);
        }
      });
    },
  },
});
</script>
<style lang="scss" scope>
  .filter-multiselect {
    position: relative;

    &.required {
      &::before{
        content: '*';
        position: absolute;
        left: -.6em;
        color: red;
      }
    }
    .multiselect__content-wrapper {
      min-width: min-content;
    }
    .multiselect__tags {
      display: flex;
      flex-flow: row;
      align-items: center;

      .multiselect__strong {
        margin: 0 0 0 4px;
        white-space: nowrap;
      }
    }
    &.multiselect--active {
      .multiselect__tags-wrap, .multiselect__strong {
        display: none;
      }
    }
  }
</style>
